<template>
  <div class="products-wrapper">
    <div class="products container">
    <coupon-float :default-collapsed="true" />
    <product-banner ref="banner" :prices="prices" @check="checkPrice"/>
    </div>
    <div class="products container products--step-wrap">
    <product-step :step="step"/>
    </div>
    <div class="products container">
    <product-templates v-show="$route.query.type === 'diarybook'"/>
    <product-design :design="design" v-show="$route.query.type !== 'calendar'"/>
    <product-typeset :typeset="typeset" v-show="typeset.title"/>
    <product-materials :material="material"/>
    <product-prices :prices="prices" :symbols="symbols" v-if="$route.query.type === 'diarybook'"/>
    <production :production="production"/>
    <modal :show="showModal" :footer="true" @close="showModal = false">
      <div slot="body">
        <div class="text-center subtitle" style="margin-bottom: 1rem;">
          {{$t('products.selectRegion')}}
        </div>
        <div class="row is-mobile">
          <div class="col-xs-6">
            <div class="control has-icons-left">
              <div class="select is-rounded">
                <select class="form-control" :value="locales" @change="changeLocale">
                  <option v-for="(item, index) in countries" :key="index" :value="item.alias">
                    {{item.label}}({{item.currency}})
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <button class="btn primary" @click="selectLocale">{{$t('button.ok')}}</button>
          </div>
        </div>
      </div>
    </modal>
    </div>
    <home-showcase @start="showSocialModal = true" />
    <product-words :title="$t('products.testimonials')" :has-bg="true" class="product-words-section" @start="showSocialModal = true"/>

    <!-- Social Network Modal — 复用首页弹窗 -->
    <div class="connect-modal-mask" v-if="showSocialModal" @click.self="showSocialModal = false">
      <div class="connect-modal">
        <div class="connect-modal__close" @click="showSocialModal = false">&times;</div>
        <h3 class="connect-modal__title">{{ $t('home.connectModalTitle') }}</h3>
        <div class="connect-modal__options">
          <a class="connect-option" :href="facebookLoginPath">
            <svg viewBox="0 0 24 24" fill="#1877F2" width="40" height="40">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/layout/Home.scss'
import config from 'src/app.config'
import ProductWords from '../views/Home/Words'
import ProductBanner from '../components/Product/Banner'
import ProductStep from '../components/Product/Step'
import ProductTemplates from '../components/Product/Templates'
import ProductDesign from '../components/Product/Design'
import ProductTypeset from '../components/Product/Typesets'
import ProductMaterials from '../components/Product/Materials'
import ProductPrices from '../components/Product/Prices'
import Production from '../components/Product/Production'
import HomeShowcase from '../views/Home/Showcase'
import { find } from 'lodash'
import { mapGetters } from 'vuex'
import api from 'src/api'
import countries from '../../static/json/country'
import currencyMixin from '../mixins/currency'
import { detectCountryByIp } from '../_utils/geo'
import { buildMeta } from 'src/utils/seo'

export default {
  name: 'Products',
  metaInfo () {
    return buildMeta({
      title: 'Products & Pricing',
      description: 'Hardcover or softcover · Premium paper · Worldwide shipping. Choose your iPastBook style and see live pricing.',
      path: '/products'
    })
  },
  mixins: [currencyMixin],
  components: {
    ProductBanner,
    ProductWords,
    ProductStep,
    ProductTemplates,
    ProductDesign,
    ProductTypeset,
    ProductMaterials,
    ProductPrices,
    Production,
    HomeShowcase,
    CouponFloat: () => import('../components/CouponFloat.vue')
  },
  data: () => ({
    prices: null,
    locales: 'TW',
    symbols: 'NT$',
    tempLocale: null,
    showModal: false,
    showSocialModal: false,
    countries
  }),
  computed: {
    ...mapGetters(['language']),
    facebookLoginPath () {
      return config.facebookLoginPath
    },
    step () {
      return {
        title: this.$t('products.stepDiarybook')
      }
    },
    typeset () {
      switch (this.$route.query.type) {
        case 'calendar':
          return {
            title: this.$t('products.typesetCalendar'),
            subtitle: this.$t('products.typesetCalendarSub'),
            image: require('../../static/images/product/typeset-calendar.png'),
            imageMobile: require('../../static/images/product/typeset-mobile-calendar.png')
          }
        case 'photobook':
          if (this.$route.query.template === 'album') {
            return {
              title: '',
              subtitle: '',
              image: require('../../static/images/product/typeset-tablet-photobook.png'),
              imageMobile: require('../../static/images/product/typeset-mobile-photobook.png')
            }
          }
          return {
            title: this.$t('products.typesetPhotobook'),
            subtitle: this.$t('products.typesetPhotobookSub'),
            image: require('../../static/images/product/typeset-tablet-photobook.png'),
            imageMobile: require('../../static/images/product/typeset-mobile-photobook.png')
          }
        case 'diarybook':
        default:
          return {
            title: this.$t('products.typesetDiarybook'),
            subtitle: '',
            image: require('../../static/images/product/typeset-tablet-diarybook.png'),
            imageMobile: require('../../static/images/product/typeset-mobile-diarybook.png')
          }
      }
    },
    material () {
      switch (this.$route.query.type) {
        case 'calendar':
          return {
            title: this.$t('products.materialTitle'),
            subtitle: this.$t('products.materialSubtitle'),
            imageOne: require('../../static/images/product/material-calendar.png'),
            imageTwo: require('../../static/images/product/material-calendar-1.png'),
            imageOneMobile: require('../../static/images/product/material-mobile-calendar.png'),
            imageTwoMobile: require('../../static/images/product/material-mobile-calendar-1.png')
          }
        case 'photobook':
          if (this.$route.query.template === 'album') {
            return {
              title: this.$t('products.materialTitle'),
              subtitle: this.$t('products.materialSubtitleShort'),
              imageOne: require('../../static/images/product/material-album.png'),
              imageTwo: require('../../static/images/product/material-2-album.png'),
              imageOneMobile: require('../../static/images/product/material-mobile-album.png'),
              imageTwoMobile: require('../../static/images/product/material-2-mobile-album.png')
            }
          }
          return {
            title: this.$t('products.materialTitle'),
            subtitle: this.$t('products.materialSubtitle'),
            imageOne: require('../../static/images/product/material-5.jpg'),
            imageTwo: require('../../static/images/product/material-6.jpg'),
            imageOneMobile: require('../../static/images/product/material-7.jpg'),
            imageTwoMobile: require('../../static/images/product/material-8.jpg')
          }
        case 'diarybook':
        default:
          return {
            title: this.$t('products.materialTitle'),
            subtitle: this.$t('products.materialSubtitleShort'),
            imageOne: require('../../static/images/product/material-1.jpg'),
            imageTwo: require('../../static/images/product/material-2.jpg'),
            imageOneMobile: require('../../static/images/product/material-3.jpg'),
            imageTwoMobile: require('../../static/images/product/material-4.jpg')
          }
      }
    },
    design () {
      switch (this.$route.query.type) {
        case 'calendar':
          return {
            title: this.$t('products.designTitle'),
            subtitle: this.$t('products.designSubtitle'),
            image: require('../../static/images/product/design-tablet-photobook.png'),
            imageMobile: require('../../static/images/product/design-mobile-photobook.png')
          }
        case 'photobook':
          if (this.$route.query.template === 'album') {
            return {
              title: this.$t('products.productParams'),
              subtitle: ' ',
              image: require('../../static/images/product/params.png'),
              imageMobile: require('../../static/images/product/param-mobile-album.png')
            }
          }
          return {
            title: this.$t('products.designTitle'),
            subtitle: this.$t('products.designSubtitle'),
            image: require('../../static/images/product/design-tablet-photobook.png'),
            imageMobile: require('../../static/images/product/design-mobile-photobook.png')
          }
        case 'diarybook':
        default:
          return {
            title: this.$t('products.designTitle'),
            subtitle: this.$t('products.designSubtitle'),
            image: require('../../static/images/product/design-tablet-diarybook.png'),
            imageMobile: require('../../static/images/product/design-mobile-diarybook.png')
          }
      }
    },
    production () {
      switch (this.$route.query.type) {
        case 'calendar':
          return {
            title: this.$t('products.shippingTitle'),
            subtitle: this.$t('products.shippingSubtitle'),
            image: require('../../static/images/product/production-calendar.png'),
            imageMobile: require('../../static/images/product/production-mobile-calendar.png')
          }
        case 'photobook':
          if (this.$route.query.template === 'album') {
            return {
              title: this.$t('products.shippingTitle'),
              subtitle: this.$t('products.shippingSubtitle'),
              image: require('../../static/images/product/production-album.png'),
              imageMobile: require('../../static/images/product/production-mobile-photobook.png')
            }
          }
          return {
            title: this.$t('products.shippingTitle'),
            subtitle: this.$t('products.shippingSubtitle'),
            image: require('../../static/images/product/production-tablet-photobook.png'),
            imageMobile: require('../../static/images/product/production-mobile-photobook.png')
          }
        case 'diarybook':
        default:
          return {
            title: this.$t('products.shippingTitle'),
            subtitle: this.$t('products.shippingSubtitle'),
            image: require('../../static/images/product/production-duration.png'),
            imageMobile: require('../../static/images/product/production-mobile-diarybook.png')
          }
      }
    }
  },
  watch: {
    locales: function (val) {
      if (val) {
        this.symbols = this.getSymbolByLocale(val)
        this.fetchPrice(true)
      }
    }
  },
  created () {
    // Default to diarybook when no type specified
    if (!this.$route.query.type) {
      this.$router.replace({ path: '/products', query: { type: 'diarybook' } })
    }
    this.$root.$on('show-social-modal', this.openSocialModal)
  },
  beforeDestroy () {
    this.$root.$off('show-social-modal', this.openSocialModal)
  },
  async mounted () {
    // 价格币种由 IP 决定，与语言无关；不支持的国家回退 US
    const cc = await detectCountryByIp()
    this.locales = cc
    this.symbols = this.getSymbolByLocale(cc)
    this.fetchPrice()
  },
  methods: {
    openSocialModal () {
      this.showSocialModal = true
    },
    fetchPrice (reload) {
      if (reload) {
        this.prices = null
      }
      api.fetchPrice(this.locales).then(data => {
        if (this.$route.query.type !== 'diarybook') {
          this.prices = find(data, { priceType: this.$route.query.type }).value
        } else {
          const bookPrices = find(data, { priceType: 'book' }).value
          Object.keys(bookPrices).map(size => {
            Object.keys(bookPrices[size]).map(item => {
              bookPrices[size][item].inner = Number(bookPrices[size][item].inner[200])
            })
          })
          this.prices = bookPrices
        }
      })
    },
    startDraw () {
      if (this.$route.query.type === 'diarybook') {
        if (this.$store.state.user.uid) {
          this.$router.push('/app/shelf')
        } else {
          this.$router.push('/app/profile')
        }
        return
      }
      const binding = this.$refs.banner.$refs.sku.selected.binding || 'fabric'
      this.$router.push(`/setup?type=magazine&binding=${binding}`)
    },
    checkPrice () {
      this.showModal = true
    },
    changeLocale (evt) {
      this.tempLocale = evt.target.value
    },
    selectLocale () {
      this.locales = this.tempLocale
      this.showModal = false
    }
  }
}
</script>

<style lang="scss">
.products {
  padding-top: 70px;
  max-width: 1200px;
  margin: 0 auto;

  &.products--step-wrap {
    padding-top: 0;
  }

  & > section {
    padding: 1.5rem 0;
    border: none !important;
    box-shadow: none !important;

    header {
      margin: 0 0 1.5rem;
      text-align: center;

      h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a2e;
        margin: .5rem 0;
      }

      .subtitle {
        color: #6b7280;
        font-size: 1rem;
        line-height: 1.6;
      }
    }

    img {
      max-width: 100%;
      margin: 0 auto;
    }

    & > .container {
      padding: 0 2rem;
    }

  }

  .product-words-section,
  .home-showcase {
    header {
      text-align: center;

      h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a2e;
      }
    }
  }

  .title-meta {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #fff;
    z-index: 30;
  }
}

@media (max-width: 768px) {
  .products {
    padding-top: 60px;
    padding-bottom: 80px;

    &.products--step-wrap {
      padding-top: 0;
      padding-bottom: 0;
    }

    & > section {
      padding: 2rem 0;

      header h2 {
        font-size: 1.5rem;
      }

      & > .container {
        padding: 0 1rem;
      }
    }
  }
}
</style>
